<template>
  <div class="testing-list-view">
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      Test Visualization
      <div slot="right">
        <b-button type="is-normal import-button" @click="redirectToReport"
          >Cancel</b-button
        >
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <div
        class="level-left validation-collapse-header-text"
        @click="togglePanel"
      >
        <h3 class="import-type-name">General Information</h3>
        <b-icon :icon="isOpen ? 'chevron-up' : 'chevron-down'"></b-icon>
      </div>
      <b-collapse class="validation-panel" animation="slide" :open="isOpen">
        <div class="card validation-card">
          <div class="card-content">
            <div class="columns">
              <div class="column columns no-margin">
                <div class="column">
                  <b-icon icon="account-circle"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns validation-text-header">Customer</div>
                  <div class="columns">
                    <span
                      class="no-padding"
                      v-if="formData && formData.customer_name"
                    >
                      {{ formData.customer_name }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="column columns no-margin">
                <div class="column">
                  <b-icon icon="flag"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns validation-text-header">Country</div>
                  <div class="columns">
                    <span
                      class="no-padding"
                      v-if="formData && formData.country_name"
                    >
                      {{ formData.country_name }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="column columns no-margin">
                <div class="column">
                  <b-icon icon="domain"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns validation-text-header">Scheme</div>
                  <div class="columns">
                    <span class="no-padding" v-if="formData && formData.scheme">
                      {{ formData.scheme_name }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="column columns no-margin" v-if="formData">
                <div class="column">
                  <b-icon icon="sine-wave"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns validation-text-header">Stream</div>
                  <div class="columns">
                    <span class="no-padding" v-if="formData">
                      {{ formData.stream_name }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="column columns no-margin" v-if="formData">
                <div class="column">
                  <b-icon icon="tag"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns no-padding validation-text-header">
                    Report Definition
                  </div>
                  <div class="columns">
                    <span class="no-padding">
                      <router-link
                        :to="
                          summaryData.sheet_config &&
                          summaryData.sheet_config.length > 0
                            ? {
                                path:
                                  '/rulesManager/tabularReportDefinition/' +
                                  formData.report_definition +
                                  '/definition-view',
                                params: { id: formData.report_definition }
                              }
                            : {
                                path:
                                  '/rulesManager/reportDefinition/' +
                                  formData.report_definition +
                                  '/definition-view',
                                params: { id: formData.report_definition }
                              }
                        "
                      >
                        {{ formData.name }}
                      </router-link>
                    </span>
                  </div>
                </div>
              </div>
              <div class="column columns no-margin">
                <div class="column">
                  <b-icon icon="calendar-clock"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns no-padding validation-text-header">
                    Period
                  </div>
                  <div class="columns">
                    <span v-if="formData" class="no-padding">
                      {{ formData.period }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-collapse>
    </section>

    <ReportManagerTabularSummary
      v-if="
        summaryData &&
          summaryData.sheet_config &&
          summaryData.sheet_config.length > 0
      "
      :data="summaryData"
      :sheet-config="summaryData.sheet_config"
      :status="summaryData.status"
      :comparableReportList="comparableReportList"
      :comparedSummaryData="comparedSummaryData"
      @upliftConfirm="applyUpliftConfirm"
      @revertUplift="revertUpliftConfirm"
      @loadCompareReportList="loadCompareReportList"
      @exportCompareReport="exportCompareReport"
      @loadCompareReport="loadCompareReport"
      @selectedTable="loadReportTable"
    />
    <report-manager-summary
      v-else
      :data="summaryData"
      :status="formData.status"
      :comparableReportList="comparableReportList"
      :comparedSummaryData="comparedSummaryData"
      @upliftConfirm="applyUpliftConfirm"
      @revertUplift="revertUpliftConfirm"
      @loadCompareReportList="loadCompareReportList"
      @exportCompareReport="exportCompareReport"
      @loadCompareReport="loadCompareReport"
    />
    <reported-item-list
      ref="reportedItemList"
      v-if="
        summaryData &&
          summaryData.sheet_config &&
          summaryData.sheet_config.length > 0
      "
      :summaryData="summaryData"
      :data="formData"
      :categoriesDropdownValues="categoryDropDown"
      :rulesDropdownValue="ruleDropDown"
      :productGroupDropDown="productGroupDropDown"
      :productFamilyDropDown="productFamilyDropDown"
      :materialDetailDropDown="materialDetailDropDown"
      :materialGeneralDropdown="materialGeneralDropdown"
      :chemistryDropDown="chemistryDropDown"
      :packagingLevelDropDown="packagingLevelDropDown"
      :packagingTypeDropDown="packagingTypeDropDown"
      :is-test="true"
    />
    <reported-item-list
      v-else
      :summaryData="summaryData"
      :data="formData"
      :categoriesDropdownValues="categoryDropDown"
      :rulesDropdownValue="ruleDropDown"
      :productGroupDropDown="productGroupDropDown"
      :productFamilyDropDown="productFamilyDropDown"
      :materialDetailDropDown="materialDetailDropDown"
      :materialGeneralDropdown="materialGeneralDropdown"
      :chemistryDropDown="chemistryDropDown"
      :packagingLevelDropDown="packagingLevelDropDown"
      :packagingTypeDropDown="packagingTypeDropDown"
      :is-test="true"
    />
    <b-loading
      :is-full-page="false"
      v-model="isSummaryLoading"
      :can-cancel="false"
    ></b-loading>
    <div class="disclaimer-footer">
      <span
        >*Fees displayed may differ from the final invoices issued by the
        respective schemes.</span
      >
    </div>
  </div>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import HeroBar from "@/components/HeroBar";
import RulesManagerService from "../../services/RulesManagerService";
import ReportManagerService from "../../services/ReportManagerDataService";
import { mapGetters } from "vuex";
import UtilityMixin from "@/mixins/UtilityMixin";
import ReportManagerSummary from "@/components/ReportsManager/ReportManagerSummary.vue";
import ReportedItemList from "@/components/ReportsManager/ReportedItemList.vue";
import ReportManagerTabularSummary from "@/components/ReportsManager/ReportManagerTabularSummary.vue";

export default {
  name: "TestingListView",
  components: {
    HeroBar,
    TitleBar,
    ReportManagerSummary,
    ReportedItemList,
    ReportManagerTabularSummary
  },
  mixins: [UtilityMixin],
  props: {
    test: {}
  },
  data() {
    return {
      summaryData: {},
      isOpen: true,
      viewRule: {},
      data: [],
      formData: [],
      reportedItemListData: [],
      isDataLoading: false,
      isViewModalActive: false,
      categoryDropDown: [],
      ruleDropDown: [],
      categories: this.$route.params.categories,
      scopeData: this.$route.params.scopeData,
      editObject: this.getClearFormObject(),
      RulesManagerService: new RulesManagerService(),
      ReportManagerService: new ReportManagerService(),
      isLoading: false,
      isSummaryLoading: false,
      productGroupDropDown: [],
      productFamilyDropDown: [],
      materialDetailDropDown: [],
      materialGeneralDropdown: [],
      chemistryDropDown: [],
      packagingLevelDropDown: [],
      packagingTypeDropDown: [],
      comparableReportList: [],
      comparedSummaryData: {},
      customerId: null,
      selectedTable: null
    };
  },
  computed: {
    ...mapGetters(["userId", "userName", "userHasPermission"]),
    editObjectName() {
      return this.editObject || this.getClearFormObject();
    },
    titleStack() {
      return [
        { url: "#", name: "Report Manager" },
        { url: "/reportManager/testingList", name: "Testing List" },
        { url: "#", name: "Test Visualization" }
      ];
    }
  },
  mounted() {
    //this.loadCompareReportList();
    this.checkExternalPermission();
    this.getReportById();
  },

  methods: {
    togglePanel() {
      return (this.isOpen = !this.isOpen);
    },
    getTestRunSummaryById(customerId) {
      this.isSummaryLoading = true;
      this.ReportManagerService.getTestRunSummaryById(
        customerId,
        this.$route.params.id,
        "test_run"
      ).subscribe(
        response => {
          this.summaryData = response;
          // Keep loading until summaryData is populated
          if (this.summaryData && Object.keys(this.summaryData).length > 0) {
            this.$nextTick(() => {
              this.isSummaryLoading = false;
            });
          }
        },
        error => {
          this.isSummaryLoading = false;
          this.handleApiError(error);
        }
      );
    },
    loadCompareReportList() {
      this.ReportManagerService.loadComparableTestReportList(
        this.$route.params.id
      ).subscribe(response => {
        this.comparableReportList = response;
      }, this.handleApiError);
    },
    loadCompareReport(id) {
      this.ReportManagerService.getReportRunCompareData(
        this.$route.params.id,
        id,
        "test_run",
        this.customerId
      ).subscribe(res => {
        this.comparedSummaryData = res;
        this.isLoading = false;
      }, this.handleApiError);
    },
    exportCompareReport(id) {
      try {
        this.ReportManagerService.exportCompareReport(
          this.$route.params.id,
          id,
          "test_run",
          this.customerId
        );
      } catch (e) {
        this.handleApiError;
      }
    },

    fetchConfigDropdown(report_definition_id) {
      this.isLoading = true;
      this.ReportManagerService.getConfigDropdownByReportDef(
        report_definition_id,
        this.$route.params.id
      ).subscribe(response => {
        this.categoryDropDown = response.report_categories;
        this.productFamilyDropDown = this.prepareDropDownArray(
          response.product_family
        );
        this.productGroupDropDown = this.prepareDropDownArray(
          response.product_group
        );
        this.materialDetailDropDown = this.prepareDropDownArray(
          response.material_detail
        );
        this.materialGeneralDropdown = this.prepareDropDownArray(
          response.material_general
        );
        this.chemistryDropDown = this.prepareDropDownArray(response.chemistry);
        this.packagingLevelDropDown = this.prepareDropDownArray(
          response.packaging_level
        );
        this.packagingTypeDropDown = this.prepareDropDownArray(
          response.packaging_type
        );
        this.ruleDropDown = response.rules;
        this.isLoading = false;
      });
    },
    prepareDropDownArray(value) {
      const result = [];
      if (value && Array.isArray(value)) {
        value.forEach(element => {
          const obj = {};
          obj["name"] = element;
          result.push(obj);
        });
      }
      return result;
    },
    getReportById() {
      this.ReportManagerService.getTestRunById(this.$route.params.id).subscribe(
        response => {
          this.formData = response;
          this.customerId = response.customer;
          this.fetchConfigDropdown(response.report_definition);
          this.getTestRunSummaryById(response.customer);
        },
        this.handleApiError
      );
    },
    getClearFormObject() {
      this.formData = [];
    },
    redirectToReport() {
      this.formData = [];
      this.$router.push({
        name: "reportManager.testingList"
      });
    },

    handleApiError(reason) {
      let errorMessage = null;
      if (reason?.response?.data) {
        if (reason.response.data["detail"]) {
          errorMessage = reason.response.data["detail"];
        } else if (reason.response.data["error"]) {
          errorMessage = reason.response.data["error"];
        } else if (reason.response.data["name"]) {
          errorMessage = reason.response.data["name"];
        } else {
          errorMessage = "Invalid input";
        }
      }
      this.isLoading = false;
      this.isSummaryLoading = false;
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true,
        onConfirm: () => this.redirectToReport()
      });
    },

    fetchScopes(formData) {
      this.RulesManagerService.getFilterScopeData(formData).subscribe(
        response => {
          this.scopeData = response.results;
        }
      );
    },

    handleJsonApiError(reason) {
      const errorMessage = reason.response.data["message"];
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true,
        onConfirm: () => this.$router.go()
      });
    },

    applyUpliftConfirm(data) {
      data["run_type"] = "Test Run";
      data["run_id"] = this.$route.params.id;
      data["stream_id"] = this.formData.stream;
      this.ReportManagerService.applyUplift(data).subscribe(response => {
        this.$buefy.dialog.alert({
          title: "Success",
          message: "Uplift applied successfully",
          onConfirm: () => this.getReportById()
        });
      }, this.handleJsonApiError);
    },
    revertUpliftConfirm() {
      this.ReportManagerService.revertUplift(
        "Test Run",
        this.$route.params.id,
        this.formData.stream
      ).subscribe(response => {
        this.$buefy.dialog.alert({
          title: "Success",
          message: "Uplift reverted successfully",
          onConfirm: () => this.getReportById()
        });
      }, this.handleJsonApiError);
    },
    loadReportTable(tableInfo) {
      this.selectedTable = tableInfo;
      if (this.$refs.reportedItemList) {
        // Handle both old string format and new object format
        if (typeof tableInfo === "object" && tableInfo.tableName) {
          this.$refs.reportedItemList.loadTable(
            tableInfo.tableName,
            tableInfo.sheetName
          );
        } else {
          // Backward compatibility for string format
          this.$refs.reportedItemList.loadTable(tableInfo, "");
        }
      }
    }
  }
};
</script>
